import { DefaultRootState } from '@databases/redux';
import { Database } from '@databases/types/database';
import { DatabaseViewSettings } from '@databases/types/database/view';
import { getDatabaseDraft } from '@databases/utils/database/changesets';
import { applyDatabaseView } from '@databases/utils/database/view/view';
import { proxy } from 'valtio';

const viewAwareDatabase = proxy<{
  databases: { [contentId: string]: Database };
  viewSettings: DatabaseViewSettings | undefined;
  setDatabase(contentId: string, database: Database): void;
  getDatabaseRequired(contentId: string): Database;
  refreshDatabase(contentId: string, database: Database, state: DefaultRootState): void;
  applyDatabaseView(
    contentId: string,
    view: DatabaseViewSettings,
    state: DefaultRootState
  ): void;
}>({
  databases: {},
  viewSettings: undefined,
  setDatabase(contentId: string, database: Database) {
    this.databases[contentId] = database;
  },
  refreshDatabase(contentId: string, database: Database, state: DefaultRootState) {
    this.databases[contentId] = database;
    if (this.viewSettings) {
      this.applyDatabaseView(contentId, this.viewSettings, state);
    }
  },
  applyDatabaseView(
    contentId: string,
    viewSettings: DatabaseViewSettings,
    state: DefaultRootState
  ): void {
    this.viewSettings = viewSettings;
    const database = this.databases[contentId];
    if (database) {
      const newDatabaseDraft = getDatabaseDraft(this.databases[contentId], []);
      this.databases[contentId] = applyDatabaseView(
        database,
        newDatabaseDraft,
        this.viewSettings,
        state
      );
    }
  },
  getDatabaseRequired(contentId: string) {
    if (!this.databases[contentId]) {
      throw new Error('Database is not set.');
    }

    return this.databases[contentId];
  },
});

export default viewAwareDatabase;
